import { isPlatformNodeJS } from '@utils/common';

function mapPollySpeed(speed) {
  var _a, _b, _c, _d, _e;
  switch (speed) {
    case 0:
      return isPlatformNodeJS() ? 1 : ((_a = window.gPolly) == null ? void 0 : _a.Speeds.X_SLOW) ?? 1;
    case 1:
      return isPlatformNodeJS() ? 2 : ((_b = window.gPolly) == null ? void 0 : _b.Speeds.SLOW) ?? 2;
    case 3:
      return isPlatformNodeJS() ? 4 : ((_c = window.gPolly) == null ? void 0 : _c.Speeds.FAST) ?? 4;
    case 4:
      return isPlatformNodeJS() ? 5 : ((_d = window.gPolly) == null ? void 0 : _d.Speeds.X_FAST) ?? 5;
    default:
      return isPlatformNodeJS() ? 3 : ((_e = window.gPolly) == null ? void 0 : _e.Speeds.MEDIUM) ?? 3;
  }
}

export { mapPollySpeed };
//# sourceMappingURL=util.map-polly-speed.js.map
